import { Component, OnInit } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { ProjectDataPerimetro } from 'src/app/entities/project-data-perimetro.entity';
import { Router, NavigationEnd } from '@angular/router';
import { ModelService } from 'src/app/services/model.service';
import { ProjectDetailService } from './project-detail.service';
//import { ProjectListService } from '../project-list/project-list.service';
import { PdfService } from 'src/app/services/pdf.service';
import { Utils } from 'src/app/utils.module';
import { LoginService } from 'src/app/login/login_service/login.service';
import { PropagarService } from 'src/app/services/propagar.service';
import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import { AppState } from 'src/app/app.reducers';
import { Budget } from 'src/app/builder/budget';
import { Subscription } from 'rxjs';
import { BuilderService } from 'src/app/builder/builder.service';

//declare var PDFDocument: any;
//declare var blobStream: any;

@Component({
	selector: 'app-project-detail',
	templateUrl: './project-detail.component.html',
	styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {

	public botones = {
		cancelar: false,
		enviar: false,
		aceptar: false,
		aceptarEnviar: false,
		editor: true,
		UIver: true,
	}

	// Proyecto a tratar.
	public projectData: ProjectData;

	// Clonación para evitar modificaciones en los calculos.
	public datos: ProjectData;
	public datosGrid: ProjectData;

	//private perimetros: Project DataPerimetro[];
	// private tieneMC: boolean = false;
	//private totalMC: number = 0;

	public moneda: string = '€';

	private path = '';
	private _iComingFrom3D = false;

	// Muestra cargando.
	public loadingCancel = false;
	public loadingAccept = false;
	public loadingSend = false;
	public loading = false;

	constructor(
		private store: Store<AppState>,
		public router: Router,
		public modelService: ModelService,
		private service: ProjectDetailService,
		private builderService: BuilderService,
		//private analyticsService: AnalyticsService,
	//	private projectListService: ProjectListService,
		private pdfService: PdfService,
		private loginService: LoginService
		//private http: Http
	) { }

	// Actualiza la botonera dinámica compuesta por los botones 'Cancelar', 'Enviar', 'Aceptar' y 'Visualizar Proyecto'.
	// ESTADOS:
	// 0 .- Borrador
	// 1.- En revisión
	// 2.- Oferta
	// 3.- Pedido
	// 4.- Acabado
	// 5.- Rechazado
	private actualizarBotones() {
		this.loadingCancel = false;
		this.loadingAccept = false;
		this.loadingSend = false;
		this.loading = false;

		const admin: boolean = this.modelService.getUser().isAdmins;
		const estado: any = this.projectData.estado;
		const list: boolean = (this.path === '/estimation-list');

		// Solo se pueden cancelar los proyectos en estado Borrador u Oferta siendo para todos los roles.
		// Solo se pueden cancelar los proyectos en estado 'En Revisión' siendo un Administrador.
		this.botones.cancelar = (admin) ? estado < 3 : estado === 0 || estado === 2;
		// Solo se puede enviar proyectos en estado Borrador, todos los Roles.
		this.botones.enviar = estado === 0;
		// Solo se puede aceptar un proyectos que esté en estado 'En Revisión' y debe tener Rol Administrador.
		this.botones.aceptar = admin && estado === 1;
		// Ir al editor solo se muestra si viene del listado de proyectos.
		this.botones.editor = list;

		// La botonera superior solo se muestra SI:
		this.botones.UIver = (estado === 0 || estado === 2) // El proyecto esta en estado 0 Borrador o 2 Oferta.
			|| list // El presupuesto se ha abierto desde el listado de proyectos.
			|| (estado === 3 && admin); // Si el proyecto está en estado 2 En Revisión y es un Administrador.

		// Ajuste de margenes.
		this.botones.aceptarEnviar = this.botones.enviar || this.botones.aceptar;
	}

	// Iniciar el componente.
	// Se puede entrar a este componente desde tres sitios:
	//		Editor Satélite.
	//		Editor Esquema.
	//		Listado de proyectos.
	public ngOnInit(): void {
		this.datosGrid = new ProjectData();

		// Comprobar si está loginado.
		this.loginService.isLoggedIn();

		this.store.subscribe(state => {
			this.path = state.uiPath.path;
			this._iComingFrom3D = state.uiPath.iComingFrom3D;
		});

		//
		var i = document.getElementById('webContents');
		if (i) i.setAttribute('style', "");

		// Tener en cuenta si viene de los editores o el listado.
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (event.url === '/project-detail') {
					this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
					this.datos = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
					if (!this.projectData) {
						this.router.navigate(['/']);
					} else {
						this.updateView();
					}
				}
			}
		});

		this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		this.datos = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		if (!this.projectData) {
			this.router.navigate(['/']);
		} else {
			console.log(this.router.url);
			this.updateView();
		}
	}

	public onClick() {
		console.log('VOLVER');
		// Tener en cuenta si es el mismo proyecto.
		const previousID = localStorage.getItem(Utils.PREVIOUS_CURRENT_PROJECT);
		let update = true;
		if (previousID) {
			// Si no es el actual proyecto no lo actualiza.
			update = (previousID !== this.projectData._id);
			// Elimina el actual proyecto del localstorage.
			localStorage.removeItem(Utils.PREVIOUS_CURRENT_PROJECT);
		}
		//console.log(`pro._id ${pro._id} !== this.project Data._id ${this.project Data._id}`);
		// Almacena en el localstorage el actual proyecto.
		if (update) localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));

		// Indicar que a la vuelta se diriga al home.
		this.store.dispatch(pathActions.home());

		// Dar un tiempo de actualización.
		if (this.projectData.renderer == Utils.SATELITE) {
			this.router.navigate(['/satelite']);
			setTimeout(() => { PropagarService.get('GProjectLoadSatelite').emit('All right!'); }, 100);
		} else {
			console.log('>>>>>>>>>>> iComingFrom3D = ' + this._iComingFrom3D);
			this.router.navigate(['/scheme']);
			setTimeout(() => { this.modelService.GProjectLoadScheme.emit('[' + this._iComingFrom3D + ']'); }, 200);
		}
	}

	// Devuelve true si está en el editor de Esquema.
	public isSCHEME2(): boolean { return this.projectData.renderer === Utils.SCHEME2; }

	// Devuelve true si está en el editor Satélite.
	public isGMAPS(): boolean { return this.projectData.renderer === Utils.SATELITE; }

	// HTML
	public formatMilesStr(value: number): string { return Utils.formatDecimal(value.toString(), 0); }

	private updateView(): void {
		this.datosGrid = new ProjectData();
		if (this.projectData.renderer === Utils.SCHEME2) {

			this.sendForAprovalEsquema();
		}
		else {
			this.updateView2();
		}
	}
	private updateView2(): void {
		// Actualizar alineamiento de los botones según estado y usuario.
		this.actualizarBotones();

		// Clonar el proyecto para evitar modificar los datos al ser mostrados en el detalle debido
		// a la condición de tener MC (Margen Comercial).
		this.datosGrid = JSON.parse(JSON.stringify(this.datos));

		// Rellena el detalle con los calculos pertinentes.
		this.datosGrid.perimetro.forEach((perimetro: ProjectDataPerimetro) => {
			const grid = [];
			perimetro.subtotal = 0;
			perimetro.vat = -1;
			if (perimetro.presupuesto.navision) {
				perimetro.presupuesto.navision.response.segmento.vProductItem.forEach((item) => {
					if (item != null) {
						perimetro.longitudStr = Utils.formatDecimal(perimetro.longitud.toString(), 3);
						if (!perimetro.longitudML) {
							perimetro.longitudML = perimetro.presupuesto.unity.ml;
						}
						perimetro.presupuesto.unity.mlStr = Utils.formatDecimal(perimetro.longitudML.toString(), 3);

						// Obtener la cantidad de unidades.
						let canStr = item.cantidad;
						if (canStr.endsWith('.00')) { canStr = canStr.replace('.00', ''); }
						else if (canStr.endsWith(',00')) { canStr = canStr.replace(',00', ''); }
						const _cantidad = parseInt(canStr.replace(',', '').replace('.', ''), 10);

						// Precio limpio sin descuentos ni MC.
						const _precio = parseFloat(item.precio.replace(',', ''));

						// Precio para el cliente se le resta el descuento y se le añade el MC.
						let _precioAUX = _precio;

						// Impuesto del p### gobierno de turno.
						if (perimetro.vat === -1 && item.iva !== '-1.00') { perimetro.vat = parseFloat(item.iva); }

						const _descuento = (item.descuento) ? parseInt(item.descuento.replace('%', ''), 10) : 0;
						if (_descuento > 0 && _precio > 0) {
							_precioAUX -= (_precio / 100) * _descuento;
						}

						// El total de la línea siempre es el precio de la unidad con el descuento y MC aplicado por la cantidad.
						const tot = _precioAUX * _cantidad;
						perimetro.subtotal += tot;

						grid.push({
							cod_producto: item.cod_producto,
							descripcion: item.descripcion,
							precio: Utils.formatDecimal(_precio.toString()) + this.moneda,
							//precioAUX: Utils.formatDecimal(_precioAUX.toString()) + this.moneda,
							descuento: _descuento + '%',
							cantidad: canStr,
							total: Utils.formatDecimal(tot.toString()) + this.moneda,
						});
					}
				});
			} else {
				console.log('DETAILS ERROR NAVISION > perimetro.presupuesto.navision = null');
			}

			if (grid.length > 0) {
				// Calcular el impuesto.
				perimetro.vatTotal = parseFloat(((perimetro.subtotal / 100) * perimetro.vat).toFixed(2));
				// Obtener el resultado final.
				perimetro.total = perimetro.vatTotal + perimetro.subtotal;
				perimetro.subtotalStr = Utils.formatDecimal(perimetro.subtotal.toString());
				perimetro.vatTotalStr = Utils.formatDecimal(perimetro.vatTotal.toString());
				perimetro.totalStr = Utils.formatDecimal(perimetro.total.toString());
			}
			perimetro.grid = grid;
		});
	}

	public sendProject(): void {
		if (!this.botones.enviar) return;
		this.loading = true;
		// Enviar a revisión.
		/*
		idClienteRivisa         El Cód. cliente en NAV (o su NIF)
		numDocumentoWS          Este es para vosotros (es el de máximo 30). Se puede dejar en blanco.
		numDocumentoCliente     Texto de hasta 250 caracteres. Se puede dejar en blanco.
		nombreDocumentoCliente  Texto de hasta 250 caracteres. Se puede dejar en blanco.
		margenComercial         De tipo Decimal; Se puede dejar a 0.
		comentario				Máximo 250 caracteres.
		vQuoteLines
			quoteLines [{
				cod_producto    El código del producto en NAV. Si queréis poner alguna información
								como “Longitud Topográfica”, o “Longitud Lineal, o lo que consideréis
								necesario, no lo informéis.
				descripcion     Informarlo para lo que deseéis. Si hay cod_producto informado
								 lo ignora. Es un texto de 50 caracteres.
				cantidad        Si se ha informado una descripción se puede dejar en blanco (o cero).
				precio          Siempre hay que informarlo. Aunque sea un 0 (no dejar en blanco).
								 Sino la línea no se importa.
			}
			...
			]
		idResponse              No hay que informarlo. Lo usamos nosotros para la respuesta.
		response                No hay que informarlo. Lo usamos nosotros para la respuesta.
		*/
		const datas = {
			idUser: this.projectData.userId
			, idProyecto: this.projectData._id
			, idClienteRivisa: this.projectData.userIdRivisa
			, numDocumentoWS: this.projectData._id
			, numDocumentoCliente: ''
			, nombreDocumentoCliente: this.projectData.nombre
			, margenComercial: this.projectData.mc
			, comentario: ' '
			, quoteLines: []
			// , idResponse: ''
			// , response: ''
		};

		const _comentarios: string[] = [];
		for (let per = 0; per < this.projectData.perimetro.length; per++) {
			const pdp = this.projectData.perimetro[per];
			// Extraer todos los comentarios.
			if (pdp.informacion && pdp.informacion.comentarios && typeof pdp.informacion.comentarios === 'string') {
				_comentarios.push('[' + (per + 1).toString() + '] ' + pdp.informacion.comentarios.trim());
			}

			//for (let det = 0; det < pdp.grid.length; det++) {
			//	datas.quoteLines.push({
			//		cod_producto: pdp.grid[det].cod_producto
			//		, descripcion: pdp.grid[det].descripcion
			//		, cantidad: pdp.grid[det].cantidad
			//		, precio: pdp.grid[det].precio.replace(this.moneda, '')
			//	});
			//}

			const _datos = pdp.presupuesto.navision.response.segmento.vProductItem;
			for (let det = 0; det < _datos.length; det++) {
				datas.quoteLines.push({
					cod_producto: _datos[det].cod_producto
					, descripcion: _datos[det].descripcion
					, cantidad: _datos[det].cantidad
					, precio: _datos[det].precio // .replace(this.moneda, '')
				});
			}
		}
		
		datas.comentario = ('[' + this.projectData.nombre + ']  ');
		
		if (_comentarios.length > 0) {
			datas.comentario = datas.comentario + _comentarios.join(' ');
		}
		
		if (datas.comentario.length > 250) {
			datas.comentario = datas.comentario.substr(0, 250); // Solo puede ir 250 carácteres.
		}

		//datas.comentario = datas.comentario.substr(0, 250); // Solo puede ir 250 carácteres.
		console.log(datas);
		
		// En caso de existir comentarios unirlos por espacio.
		//if(_comentarios.length > 0){
			//datas.comentario = _comentarios.join(' ' + datas.nombreDocumentoCliente)
		//	datas.comentario = ('[' + this.projectData.nombre + ']:' + _comentarios)
		//	datas.comentario = _comentarios.join(' ');
		//	datas.comentario = datas.comentario.substr(0, 250); // Solo puede ir 250 carácteres.
		//}else{
		//	datas.comentario = ('[' + this.projectData.nombre + ']')
		///	datas.comentario = _comentarios.join(' ');
			//datas.comentario = datas.comentario.substr(0, 250); // Solo puede ir 250 carácteres.
		//}

		this.service.sendProject(datas).subscribe(
			(result) => {
				if (result.idResponse === 0) {
					// Todo correcto, modificar poner el projectoen pendiente.
					this.projectData.estado = 1; // En revisión.
					this.service.updateProject(this.projectData).subscribe(
						() => {
							this.saveProjectData();
							this.projectData.estado = 1;
						},
						error => {
							console.log('# sendProject CLIENT ', error);
						});
				} else {
					// Errores en datos.
					console.log('# Error en datos -> ', result.response);
				}
				this.actualizarBotones();
			}
			, (error) => {
				// Error de conexión.
				this.actualizarBotones();
				console.log(error);
			});
	}

	// Acepta el proyecto.
	public acceptProject(): void {
		if (this.botones.aceptar) {

			this.projectData.estado = 3;
			this.service.updateProject(this.projectData).subscribe(() => {
				this.saveProjectData();
				this.actualizarBotones();
			});
		}
	}

	// Cancela el proyecto.
	public cancelProject(): void {
		if (this.botones.cancelar) {

			this.projectData.estado = 5;
			this.service.updateProject(this.projectData).subscribe(() => {
				this.saveProjectData();
				this.actualizarBotones();
			});
		}
	}

	private saveProjectData(): void {
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectData));
	}

	public formatoDecimalStr(value: number) { return Utils.formatDecimal(value.toString()); }

	public get currentStatus(): string { return this.projectData.estado.toString(); }

	// ###################################################################
	public getPDF(conMC: boolean): void {
		this.pdfService.getPDF(this.datosGrid).subscribe(data => {
			if (data) {
				this.pdfService.createPDF(data, conMC);
			} else {
				// Error
				this.pdfService.createPDF(null, conMC);
			}
		});
	}

	//#region #################### CREAR PRESUPUESTO ESQUEMA
	// Crear el pedido y enviarlo a Navision para recibir el presupuesto.
	public sendForAprovalEsquema() {
		// Crear un nuevo presupuesto.
		let budget = new Budget(this.projectData);
		this.loading = true;

		if (this.projectData.userIdRivisa == undefined || this.projectData.userIdRivisa == '') {
			this.projectData.userIdRivisa = this.modelService.getUser().getData().numCliRivisa;
			console.error("projectData.userIdRivisa is undefined or empty.");
			this.loading = false;
			return;
		}

		if (budget.createBudget()) {
			//############################################################################
			//############################################################################
			//## USO EXCLUSIVO PARA DESARROLLO, SOLO SE CUMPLE EN LOCAL.
			//if (document.location.origin.includes('localhost:7890')) {
				//if (!verPresupuesto) this.currentViewMode = this.VIEW_MODE.M3D;
			//	this.updateView2();
			//	return;
			//}
			//############################################################################
			//############################################################################


			// Hacer la petición a Node para que devuelva el presupuesto calculado.
			let subs: Subscription = this.builderService.budget(this.projectData).subscribe(
				(response) => {
					// Si todo fue bien redireccionamos al detalle del proyecto.
					subs.unsubscribe();
					this.projectData = response;
					this.datos = JSON.parse(JSON.stringify(this.projectData));
					//this.onProjectUpdate();
					localStorage.setItem(Utils.PREVIOUS_CURRENT_PROJECT, this.projectData._id);
					this.updateView2();
				},
				(error) => {
					// Puede que Navision no esté operativo.
					console.error('Budget', error);
					this.updateView2();
				});
		}
		else {
			// ERROR, no se ha podido crear los datos para el servidor, no se ha hecho la petición a Node.
			this.loading = false;
			console.error(budget.result.error.message);
		}
	}
}
